import React, { useContext, useEffect } from 'react';
import { Row, Col, Card, Badge, ProgressBar } from 'react-bootstrap';
import { 
  Users, 
  Truck, 
  Package, 
  IndianRupee,
  TrendingUp,
  CreditCard,
  AlertTriangle,
  MessageSquare,
  Activity
} from 'lucide-react';
import AdminMasterLayout from '../../../layouts/admin/AdminMasterLayout '
import '../../../assets/styles/admin/AdminDashboard.css'
import AppContext from '../../../context/AppContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {

  const {loggedInAdmin} = useContext(AppContext);
  const {baseUrl} = useContext(AppContext);
  const navigate = useNavigate();
  // Stats data
  const statsData = [
    {
      id: 1,
      title: 'Total Customers',
      value: '1000',
      // change: '+12.5%',
      // subtitle: 'vs last month',
      icon: Users,
      iconBg: '#e0f2fe',
      // iconColor: '#0284c7'
    },
    {
      id: 2,
      title: 'Active Distributors',
      value: '10',
      // change: '+8.2%',
      // subtitle: 'vs last month',
      icon: Truck,
      iconBg: '#d1fae5',
      // iconColor: '#059669'
    },
    // {
    //   id: 3,
    //   title: 'Active Suppliers',
    //   value: '42',
    //   change: '+3.1%',
    //   subtitle: 'vs last month',
    //   icon: Package,
    //   iconBg: '#d1fae5',
    //   iconColor: '#059669'
    // },
    {
      id: 4,
      title: 'Monthly Revenue',
      value: 'Rs 2000',
      // change: '+18.7%',
      // subtitle: 'vs last month',
      icon: IndianRupee,
      iconBg: '#dbeafe',
      iconColor: '#2563eb'
    }
  ];

  // Recent payments
  const recentPayments = [
    {
      id: 1,
      name: 'Ahmad Dairy',
      plan: 'Premium',
      date: 'Feb 15, 2026',
      amount: 'Rs 1,00',
      status: 'completed'
    },
    {
      id: 2,
      name: 'Hassan Milk ',
      plan: 'Standard',
      date: 'Feb 14, 2026',
      amount: 'Rs 500',
      status: 'completed'
    },
    {
      id: 3,
      name: 'Bilal Fresh Milk',
      plan: 'Basic',
      date: 'Feb 14, 2026',
      amount: 'Rs 1200',
      status: 'pending'
    }
  ];

  // Expired subscriptions
  const expiredSubscriptions = [
    {
      id: 1,
      name: 'Karachi Dairy Hub',
      plan: 'Premium',
      expiredDate: 'Feb 10, 2026',
      customers: 20
    },
    {
      id: 2,
      name: 'Multan Pure Milk',
      plan: 'Basic',
      expiredDate: 'Feb 8, 2026',
      customers: 15
    },
    {
      id: 3,
      name: 'Faisalabad Dairy',
      plan: 'Standard',
      expiredDate: 'Feb 5, 2026',
      customers: 15
    }
  ];

  // Recent disputes
  // const recentDisputes = [
  //   {
  //     id: '#D-1024',
  //     title: 'Wrong quantity recorded',
  //     customer: 'Ali Raza',
  //     date: 'Feb 15, 2026',
  //     status: 'open'
  //   },
  //   {
  //     id: '#D-1023',
  //     title: 'Overcharged for milk',
  //     customer: 'Fatima Bibi',
  //     date: 'Feb 14, 2026',
  //     status: 'in review'
  //   },
  //   {
  //     id: '#D-1022',
  //     title: 'Milk quality complaint',
  //     customer: 'Usman Ahmed',
  //     date: 'Feb 13, 2026',
  //     status: 'resolved'
  //   }
  // ];

  // Support tickets
  // const supportTickets = [
  //   {
  //     id: '#T-2048',
  //     title: 'Cannot scan QR codes',
  //     user: 'Bilal Fresh Milk',
  //     date: 'Feb 15, 2026',
  //     priority: 'high'
  //   },
  //   {
  //     id: '#T-2047',
  //     title: 'Payment not reflecting',
  //     user: 'Ayesha Khan',
  //     date: 'Feb 14, 2026',
  //     priority: 'medium'
  //   },
  //   {
  //     id: '#T-2046',
  //     title: 'Need plan downgrade',
  //     user: 'Punjab Dairy Farm',
  //     date: 'Feb 13, 2026',
  //     priority: 'low'
  //   }
  // ];

  // Recent activity
  // const recentActivity = [
  //   {
  //     id: 1,
  //     user: 'Ahmad Khan',
  //     action: 'registered as distributor',
  //     time: '2 minutes ago'
  //   },
  //   {
  //     id: 2,
  //     user: 'Fatima Bibi',
  //     action: 'subscribed to Basic Plan',
  //     time: '15 minutes ago'
  //   },
  //   {
  //     id: 3,
  //     user: 'Ali Raza',
  //     action: 'raised a dispute #1024',
  //     time: '1 hour ago'
  //   },
  //   {
  //     id: 4,
  //     user: 'Milk Fresh Co.',
  //     action: 'registered as supplier',
  //     time: '2 hours ago'
  //   },
  //   {
  //     id: 5,
  //     user: 'Hassan Dairy',
  //     action: 'upgraded to Premium Plan',
  //     time: '3 hours ago'
  //   }
  // ];

  // // Platform overview
  // const platformOverview = [
  //   {
  //     id: 1,
  //     label: 'Active Subscriptions',
  //     value: 82,
  //     variant: 'primary'
  //   },
  //   {
  //     id: 2,
  //     label: 'Payment Collection Rate',
  //     value: 91,
  //     variant: 'success'
  //   },
  //   {
  //     id: 3,
  //     label: 'Dispute Resolution',
  //     value: 76,
  //     variant: 'success'
  //   },
  //   {
  //     id: 4,
  //     label: 'Customer Retention',
  //     value: 94,
  //     variant: 'primary'
  //   }
  // ];

  const dashboardStats = () => {
    console.log("adminId");
    const formData = new FormData();
    formData.append("admin_id", loggedInAdmin.id);

    axios.
    post(`${baseUrl}/admin/dashboard/dashboardStats`,
    formData, {header:{
        'Content-type' : 'multipart-formdata'
      }})
      .then((response) => {
        console.log(response.data);
        console.log("total customer", response.data.customer);
        console.log("total distributor", response.data.distributor);
        console.log("total revenue", response.data.subscriptions);
        
      })

  }

  useEffect(()=>{
    console.log("this is stored admin",loggedInAdmin);
    dashboardStats();
  },[]);

  return (
    <AdminMasterLayout>
      <div className="admin-dashboard-wrapper">
        {/* Page Header */}
        <div className="admin-dashboard-header">
          <h1 className="admin-dashboard-title">Dashboard</h1>
          <p className="admin-dashboard-subtitle">Welcome back! Here's your platform overview.</p>
        </div>

        {/* Stats Cards */}
        <Row className="admin-dashboard-stats-row g-3 g-lg-4">
          {statsData.map((stat, index) => (
            <Col xs={12} sm={6} xl={3} key={stat.id}>
              <Card 
                className="admin-dashboard-stat-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <Card.Body>
                  <div className="admin-dashboard-stat-header">
                    <span className="admin-dashboard-stat-label">{stat.title}</span>
                    <div 
                      className="admin-dashboard-stat-icon-box"
                      style={{ backgroundColor: stat.iconBg }}
                    >
                      <stat.icon 
                        size={20}
                        style={{ color: stat.iconColor }}
                        strokeWidth={2}
                      />
                    </div>
                  </div>
                  <h3 className="admin-dashboard-stat-value">{stat.value}</h3>
                  <div className="admin-dashboard-stat-meta">
                    <span className="admin-dashboard-stat-change">
                      <TrendingUp size={14} strokeWidth={2} />
                      {stat.change}
                    </span>
                    <span className="admin-dashboard-stat-period">{stat.subtitle}</span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Recent Payments & Expired Subscriptions */}
        <Row className="g-3 g-lg-4 mt-2">
          <Col xs={12} lg={6}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <CreditCard size={20} className="admin-dashboard-section-icon" />
                    <h4 className="admin-dashboard-section-title">Recent Payments</h4>
                  </div>
                  <a href="#view" className="admin-dashboard-view-link">View All</a>
                </div>

                <div className="admin-dashboard-items-list">
                  {recentPayments.map((payment, index) => (
                    <div 
                      key={payment.id} 
                      className="admin-dashboard-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-item-info">
                        <h5 className="admin-dashboard-item-name">{payment.name}</h5>
                        <p className="admin-dashboard-item-meta">
                          {payment.plan} • {payment.date}
                        </p>
                      </div>
                      <div className="admin-dashboard-item-actions">
                        <span className="admin-dashboard-item-amount">{payment.amount}</span>
                        <Badge 
                          bg={payment.status === 'completed' ? 'success' : 'warning'}
                          className="admin-dashboard-status-badge"
                        >
                          {payment.status}
                        </Badge>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} lg={6}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <AlertTriangle size={20} className="admin-dashboard-section-icon admin-dashboard-icon-warning" />
                    <h4 className="admin-dashboard-section-title">Expired Subscriptions</h4>
                  </div>
                  <a href="#view" className="admin-dashboard-view-link" onClick={()=> navigate("/admin/subscriptions")}>View All</a>
                </div>

                <div className="admin-dashboard-items-list">
                  {expiredSubscriptions.map((sub, index) => (
                    <div 
                      key={sub.id} 
                      className="admin-dashboard-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-item-info">
                        <h5 className="admin-dashboard-item-name">{sub.name}</h5>
                        <p className="admin-dashboard-item-meta">
                          {sub.plan} • Expired: {sub.expiredDate}
                        </p>
                      </div>
                      <div className="admin-dashboard-item-actions">
                        <span className="admin-dashboard-customers-count">
                          {sub.customers} customers
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        Recent Disputes & Support Tickets
        <Row className="g-3 g-lg-4 mt-2">
          <Col xs={12} lg={12}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <AlertTriangle size={20} className="admin-dashboard-section-icon admin-dashboard-icon-danger" />
                    {/* <h4 className="admin-dashboard-section-title">Recent Disputes</h4> */}
                  </div>
                  <a href="#view" className="admin-dashboard-view-link" onClick={()=> navigate("/admin/disputes")}>View All</a>
                </div>

                <div className="admin-dashboard-items-list">
                  {/* {recentDisputes.map((dispute, index) => (
                    <div 
                      key={dispute.id} 
                      className="admin-dashboard-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-item-info">
                        <h5 className="admin-dashboard-item-name">{dispute.title}</h5>
                        <p className="admin-dashboard-item-meta">
                          {dispute.id} • {dispute.customer} • {dispute.date}
                        </p>
                      </div>
                      <div className="admin-dashboard-item-actions">
                        <Badge 
                          bg={dispute.status === 'open' ? 'danger' : dispute.status === 'resolved' ? 'success' : 'warning'}
                          className="admin-dashboard-status-badge"
                        >
                          {dispute.status}
                        </Badge>
                      </div>
                    </div>
                  ))} */}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* <Col xs={12} lg={6}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <MessageSquare size={20} className="admin-dashboard-section-icon admin-dashboard-icon-info" />
                    <h4 className="admin-dashboard-section-title">Recent Support Tickets</h4>
                  </div>
                  <a href="#view" className="admin-dashboard-view-link" onClick={()=> navigate("/admin/disputes")}>View All</a>
                </div>

                <div className="admin-dashboard-items-list">
                  {supportTickets.map((ticket, index) => (
                    <div 
                      key={ticket.id} 
                      className="admin-dashboard-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-item-info">
                        <h5 className="admin-dashboard-item-name">{ticket.title}</h5>
                        <p className="admin-dashboard-item-meta">
                          {ticket.id} • {ticket.user} • {ticket.date}
                        </p>
                      </div>
                      <div className="admin-dashboard-item-actions">
                        <Badge 
                          bg={ticket.priority === 'high' ? 'danger' : ticket.priority === 'medium' ? 'warning' : 'info'}
                          className="admin-dashboard-status-badge"
                        >
                          {ticket.priority}
                        </Badge>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col> */}
        </Row>

        {/* Recent Activity & Platform Overview */}
        {/* <Row className="g-3 g-lg-4 mt-2 mb-4">
          <Col xs={12} lg={6}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <Activity size={20} className="admin-dashboard-section-icon" />
                    <h4 className="admin-dashboard-section-title">Recent Activity</h4>
                  </div>
                  <a href="#view" className="admin-dashboard-view-link">View All</a>
                </div>

                <div className="admin-dashboard-activity-list">
                  {recentActivity.map((activity, index) => (
                    <div 
                      key={activity.id} 
                      className="admin-dashboard-activity-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-activity-icon">
                        <Users size={16} strokeWidth={2} />
                      </div>
                      <div className="admin-dashboard-activity-content">
                        <p className="admin-dashboard-activity-text">
                          <strong>{activity.user}</strong> {activity.action}
                        </p>
                        <span className="admin-dashboard-activity-time">{activity.time}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} lg={6}>
            <Card className="admin-dashboard-section-card">
              <Card.Body>
                <div className="admin-dashboard-section-header">
                  <div className="admin-dashboard-section-title-wrapper">
                    <TrendingUp size={20} className="admin-dashboard-section-icon admin-dashboard-icon-success" />
                    <h4 className="admin-dashboard-section-title">Platform Overview</h4>
                  </div>
                </div>

                <div className="admin-dashboard-progress-list">
                  {platformOverview.map((item, index) => (
                    <div 
                      key={item.id} 
                      className="admin-dashboard-progress-item"
                      style={{ animationDelay: `${index * 0.05}s` }}
                    >
                      <div className="admin-dashboard-progress-header">
                        <span className="admin-dashboard-progress-label">{item.label}</span>
                        <span className="admin-dashboard-progress-value">{item.value}%</span>
                      </div>
                      <ProgressBar 
                        now={item.value} 
                        variant={item.variant}
                        className="admin-dashboard-progress-bar"
                      />
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
      </div>
    </AdminMasterLayout>
  );
};

export default AdminDashboard;